import React from 'react';
import PropTypes from 'prop-types';

import { ButtonWrapper } from './styles';

import colors from '~/styles/colors';

export default function Button({ type, icon, text, color, disabled, ...rest }) {
  return (
    /* eslint-disable react/button-has-type */
    <ButtonWrapper type={type} color={color} disabled={disabled} {...rest}>
      {icon && <div>{icon()}</div>}
      <span>{text}</span>
    </ButtonWrapper>
    /* eslint-enable react/button-has-type */
  );
}

Button.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  type: 'button',
  color: colors.pink900,
  icon: null,
  disabled: false,
};
